module.exports = __webpack_public_path__ + "img/synopsis.fb2353ab.jpg";